import { createApi } from '@reduxjs/toolkit/query/react';
import { apiInterceptor } from './apiBaseQuerySetting';
export var parkingSplitApi = createApi({
    reducerPath: 'parkingSplitApi',
    baseQuery: apiInterceptor,
    endpoints: function () { return ({}); },
    keepUnusedDataFor: 1,
    refetchOnMountOrArgChange: true,
});
